import { RiserState } from "@app/types/facilityTypes";

export const initialState: RiserState = {
    createRiserInProcess: false,
    isFetching: false,
    isLoading: false,
    removeRiserInProcess: false,
    risers: [],
    updateRiserInProcess: false,
}